import { User } from '@app/shared/interfaces/user';
import { Observable } from 'rxjs';

export const USERS_REPOSITORY = 'UsersRepository';

export interface UsersRepository {
  getItems(): Observable<any>;

  add(user: User): Observable<any>;

  edit(user: User): Observable<any>;

  delete(item: any): Observable<any>;
}
